<template>
    <div class="container-fluid p-0">
        <div v-if="!is_payment"
             class="row col-lg-12 m-0 p-0"
             v-loading="loading">
            <Keypress key-event="keyup"
                      :key-code="112"
                      @success="handleFn112"/>
            <!-- F4 -->
            <Keypress :key-code="115"
                      key-event="keyup"
                      @success="handleFn115"/>
            <div class="col-lg-7 col-md-6" style="height: calc(100vh - 60px);">
                <div class="row" style="background-color: #fff; height: 42px">
                    <div class="col-6" style="display: flex; align-items: center">
                        <el-switch v-model="search_item_by_barcode"
                                   active-text="Buscar con escaner de código de barras"
                                   @change="changeSearchItemBarcode"></el-switch>
                    </div>
                    <div class="col-6" style="display: flex; align-items: center; justify-content: end;">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="Todas las categorías"
                                    placement="top-start">
                            <button type="button"
                                    @click="back()"
                                    class="btn btn-custom btn-sm">
                                <i class="fa fa-border-all"></i>
                            </button>
                        </el-tooltip>
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="Categorías y productos"
                                    placement="top-start">
                            <button type="button"
                                    :disabled="place === 'cat2'"
                                    @click="setView('cat2')"
                                    class="btn btn-custom btn-sm ml-2">
                                <i class="fa fa-bars"></i>
                            </button>
                        </el-tooltip>
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="Listado de todos los productos"
                                    placement="top-start">
                            <button type="button"
                                    :disabled="place === 'cat3'"
                                    @click="setView('cat3')"
                                    class="btn btn-custom btn-sm ml-2">
                                <i class="fas fa-list-ul"></i>
                            </button>
                        </el-tooltip>
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="Regresar"
                                    placement="top-start">
                            <button type="button"
                                    :disabled="place === 'cat'"
                                    @click="back()"
                                    class="btn btn-custom btn-sm ml-2">
                                <i class="fa fa-undo"></i>
                            </button>
                        </el-tooltip>
                    </div>
                </div>
                <template v-if="!search_item_by_barcode">
                    <el-input v-show="place === 'prod' || place === 'cat2' || place === 'cat3'"
                              placeholder="Buscar productos"
                              size="medium"
                              v-model="input_item"
                              @input="searchItems"
                              @keyup.native="keyupTabCustomer"
                              @keyup.enter.native="keyupEnterAddItem"
                              class="m-bottom mt-3"
                              ref="ref_search_items">
                        <el-button slot="append"
                                   icon="el-icon-plus"
                                   @click.prevent="showDialogNewItem = true"></el-button>
                    </el-input>
                </template>
                <template v-else>
                    <el-input v-show="place === 'prod' || place === 'cat2' || place === 'cat3'"
                              placeholder="Buscar productos por codigo de barras"
                              size="medium"
                              v-model="input_item"
                              @change="searchItemsBarcode"
                              @keyup.native="keyupTabCustomer"
                              ref="ref_search_items"
                              class="m-bottom mt-3"
                              @focus="searchFromBarcode = true"
                              @blur="searchFromBarcode = false">
                        <el-button slot="append"
                                   icon="el-icon-plus"
                                   @click.prevent="showDialogNewItem = true"></el-button>
                    </el-input>
                </template>
                <div v-if="place === 'cat2'" class="container testimonial-group">
                    <div class="row text-center flex-nowrap">
                        <div v-for="(item, index) in categories"
                             @click="filterCategories(item.id, true)"
                             :style="{ backgroundColor: item.color }"
                             :key="index"
                             class="col-sm-3 pointer">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <br/>
                <div v-if="place === 'cat'" class="row no-gutters">
                    <template v-for="(item, index) in categories">
                        <div class="col" :key="index">
                            <div @click="filterCategories(item.id)" class="card p-0 m-0 mb-1 mr-1 text-center">
                                <div :style="{ backgroundColor: item.color }"
                                     class="card-body pointer rounded-0"
                                     style="font-weight: bold;color: white;font-size: 18px;">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div style="width: 100%; height: 100%; overflow-y: auto; overflow-x: hidden" v-if="place === 'prod' || place === 'cat2'">
                  <div class="row">
                      <div class="col-6 col-xl-3 col-lg-4 col-md-6"
                           v-for="(item, index) in items"
                           :key="index">
                          <div class="card" style="background-color: #fff">
                              <div class="card-body pointer"
                                   style="margin: 0; padding: 8px;"
                                   @click="clickAddItem(item, index)">
                                  <div class="font-weight-semibold mb-0"
                                       v-if="descriptionLength(item) > 50"
                                       data-toggle="tooltip"
                                       data-placement="top"
                                       style="height: 60px"
                                       :title="item.name">
                                      {{ item.name.substring(0, 50) }}
                                  </div>
                                  <div class="font-weight-semibold mb-0"
                                       style="height: 60px"
                                       v-else>
                                      {{ item.name }}
                                  </div>
                                  <div style="height: 100px; width: 100%; padding: 0; text-align: center;">
                                      <img :src="item.image_url"
                                           class="img-thumbail" style="height: 100%; max-width: 100%"/>
                                  </div>
                                  <div style="padding: 0; width: 100%" v-if="item.internal_id">
                                      <div class="text-muted font-weight-lighter">
                                          {{ item.internal_id }}
                                      </div>
                                  </div>
                                  <div style="padding: 0; width: 100%" v-if="item.sets.length > 0">
                                      <div class="text-muted font-weight-lighter">
                                          {{ item.sets.join("-") }}
                                      </div>
                                  </div>
                              </div>
                              <div class="card-footer bg-primary rounded flex-wrap" style="width:100% !important; padding:0 !important; ">
                                  <template v-if="!item.edit_unit_price">
                                      <div class="col-12 mt-1">
                                          <h5 class="font-weight-semibold text-right text-white">
                                              <button v-if="configuration.options_pos && edit_unit_price"
                                                      type="button"
                                                      class="btn btn-outline-light btn-xs"
                                                      @click="clickOpenInputEditUP(index)">
                                                  <span style="font-size:16px;">&#9998;</span>
                                              </button>
                                              ({{ item.unit_type_id }})
                                              {{ item.currency_type_symbol }}
                                              {{ item.sale_unit_price }}
                                          </h5>
                                      </div>
                                  </template>
                                  <template v-else>
                                      <div class="col-12 mt-1">
                                          <el-input min="0"
                                                    v-model="item.edit_sale_unit_price"
                                                    class="mt-3 mb-3"
                                                    size="mini"
                                                    :id="`editprice_${index}`">
                                              <el-button slot="append"
                                                         icon="el-icon-check"
                                                         type="primary"
                                                         @click.prevent="clickEditUnitPriceItem(index)"></el-button>
                                              <el-button slot="append"
                                                         icon="el-icon-close"
                                                         type="danger"
                                                         @click.prevent="clickCancelUnitPriceItem(index)"></el-button>
                                          </el-input>
                                      </div>
                                  </template>
                                  <template v-if="configuration.options_pos">
                                      <div class="mt-1">
                                          <el-row style="width:100%" class="mt">
                                              <el-col :span="6">
                                                  <el-tooltip class="item"
                                                              effect="dark"
                                                              content="Visualizar stock"
                                                              placement="bottom-end">
                                                      <button style="width:100%"
                                                              type="button"
                                                              class="btn btn-outline-light btn-xs"
                                                              @click.prevent="clickWarehouseDetail(item)">
                                                          <i class="fa fa-search"></i>
                                                      </button>
                                                  </el-tooltip>
                                              </el-col>
                                              <el-col :span="6">
                                                  <el-tooltip class="item"
                                                              effect="dark"
                                                              content="Visualizar historial de ventas del producto (precio venta) y cliente"
                                                              placement="bottom-end">
                                                      <button type="button"
                                                              style="width:100%;"
                                                              class="btn btn-outline-light btn-xs"
                                                              @click.prevent="clickHistorySales(item.item_id)">
                                                          <i class="fa fa-list"></i>
                                                      </button>
                                                  </el-tooltip>
                                              </el-col>
                                              <el-col :span="6">
                                                  <el-tooltip class="item"
                                                              effect="dark"
                                                              content="Visualizar historial de compras del producto (precio compra)"
                                                              placement="bottom-end">
                                                      <button type="button"
                                                              style="width:100%"
                                                              class="btn btn-outline-light btn-xs"
                                                              @click.prevent="clickHistoryPurchases(item.item_id)">
                                                          <i class="fas fa-cart-plus"></i>
                                                      </button>
                                                  </el-tooltip>
                                              </el-col>
                                              <el-col :span="6">
                                                  <el-tooltip class="item"
                                                              effect="dark"
                                                              content="Visualizar precios disponibles"
                                                              placement="bottom-end">
                                                      <el-popover placement="top"
                                                                  title="Precios"
                                                                  width="370"
                                                                  trigger="click">
                                                          <el-table v-if="item.unit_type"
                                                                    :data="item.unit_type">
                                                              <el-table-column width="90" label="Precio">
                                                                  <template slot-scope="{row}">
                                                                          <span v-if="row.price_default === 1">
                                                                              {{ row.price1 }}
                                                                          </span>
                                                                      <span v-else-if="row.price_default === 2">
                                                                              {{ row.price2 }}
                                                                          </span>
                                                                      <span v-else-if="row.price_default === 3">
                                                                              {{ row.price3 }}
                                                                          </span>
                                                                  </template>
                                                              </el-table-column>
                                                              <el-table-column width="80"
                                                                               label="Unidad"
                                                                               property="unit_type_id"></el-table-column>
                                                              <el-table-column width="120"
                                                                               label="Descripción"
                                                                               property="description"></el-table-column>
                                                              <el-table-column width="80"
                                                                               label="">
                                                                  <template slot-scope="{row}">
                                                                      <button @click.prevent="setPriceItem(row, index)"
                                                                              type="button"
                                                                              class="btn btn-custom btn-xs">
                                                                          <i class="fas fa-check"></i>
                                                                      </button>
                                                                  </template>
                                                              </el-table-column>
                                                          </el-table>
                                                          <button slot="reference"
                                                                  type="button"
                                                                  style="width:100%"
                                                                  class="btn btn-outline-light btn-xs">
                                                              <i class="fa fa-money-bill-alt"></i>
                                                          </button>
                                                      </el-popover>
                                                  </el-tooltip>
                                              </el-col>
                                              <el-col :span="6" v-if="allowedChangeAffectationExoneratedIgv(item.sale_affectation_igv_type_id)">
                                                  <el-tooltip class="item" effect="dark"
                                                              content="Modificar el tipo de afectación"
                                                              placement="bottom-end">
                                                      <el-popover placement="top"
                                                                  title="Seleccionar tipo de afectación"
                                                                  width="330"
                                                                  trigger="click">
                                                          <div v-for="(row, index) in getAffectationExoneratedIgv"
                                                               class="pt-1 mt-1 pb-1">
                                                              <el-radio v-model="item.sale_affectation_igv_type_id"
                                                                        :label="row.id"
                                                                        @change="changeAffectationExoneratedIgv(row, item)">
                                                                  {{ row.description }}
                                                              </el-radio>
                                                          </div>
                                                          <button slot="reference" style="width:100%" type="button"
                                                                  class="btn btn-outline-light btn-xs">
                                                              <i class="fas fa-sync-alt"></i>
                                                          </button>
                                                      </el-popover>
                                                  </el-tooltip>
                                              </el-col>
                                          </el-row>
                                      </div>
                                  </template>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>

                <table-items ref="table_items"
                             @clickAddItem="clickAddItem"
                             @clickWarehouseDetail="clickWarehouseDetail"
                             @clickHistorySales="clickHistorySales"
                             @clickHistoryPurchases="clickHistoryPurchases"
                             v-if="place === 'cat3'"
                             :records="items"
                             :typeUser="typeUser"
                             :visibleTagsCustomer="focusClienteSelect"
                             :searchFromBarcode="searchFromBarcode"
                             :originIsGarage="true"></table-items>

                <div v-if="place === 'prod' || place === 'cat2'" class="row">
                    <div class="col-md-12 text-center">
                        <el-pagination @current-change="getRecords"
                                       layout="total, prev, pager, next"
                                       :total="pagination.total"
                                       :current-page.sync="pagination.current_page"
                                       :page-size="pagination.per_page"></el-pagination>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-6 bg-white" style="height: calc(100vh - 60px); padding: 0; overflow: scroll; ">
                <div style="position: relative; width: 100%; height: 100%">
                    <div style="position: relative; width: 100%; height: 100%; padding: 8px">
                        <div class="row">
                            <div class="col-8" style="display: flex; justify-content: space-between;">
                                <el-radio-group v-model="form.document_type_id"
                                                size="small"
                                                @change="filterSeries">
                                    <el-radio-button label="01">FACTURA</el-radio-button>
                                    <el-radio-button label="03">BOLETA</el-radio-button>
                                    <el-radio-button label="80">N. VENTA</el-radio-button>
                                </el-radio-group>
                                <el-select v-model="form.series" style="height: 30px; width: 80px!important;">
                                    <el-option v-for="option in series"
                                               :key="option.id"
                                               :label="option.number"
                                               :value="option.number">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-4" style="display: flex; align-items: center">
                                <div style="width: 100px;">T/C {{ form.exchange_rate_sale }}</div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 8px;">
                            <div class="col-8">
                                <el-select ref="select_person"
                                           v-model="form.customer_id"
                                           filterable
                                           placeholder="Cliente"
                                           @change="changeCustomer"
                                           @keyup.native="keyupCustomer"
                                           @keyup.enter.native="keyupEnterCustomer"
                                           @focus="focusClienteSelect = true"
                                           @blur="focusClienteSelect = false">
                                    <el-option v-for="option in customers"
                                               :key="option.id"
                                               :label="option.description"
                                               :value="option.id"></el-option>
                                </el-select>
                            </div>
                            <div class="col-4">
                                <div class="btn-group d-flex" role="group">
                                    <a class="btn btn-sm btn-default w-100"
                                       @click.prevent="showDialogNewPerson = true">
                                        <i class="fas fa-plus fa-wf"></i>
                                    </a>
                                    <a class="btn btn-sm btn-default w-100"
                                       @click="clickCustomerRemove">
                                        <i class="fas fa-trash fa-wf"></i>
                                    </a>
                                    <a class="btn btn-sm btn-default w-100"
                                       @click="selectCurrencyType">
                                        <template v-if="form.currency_type_id === 'PEN'">
                                            <strong>S/</strong>
                                        </template>
                                        <template v-else>
                                            <strong>$</strong>
                                        </template>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 8px;" v-if="filter_discounts.length > 0">
                            <div class="col">
                                <x-select v-model="form.filter_discount_id"
                                          placeholder="Seleccionar descuento"
                                          :options="filter_discounts"
                                          @input="changeFilterDiscounts"></x-select>
                            </div>
                            <div class="col-auto">
                                <a class="btn btn-sm btn-default w-100"
                                   @click="removeFilterDiscounts">
                                    <i class="fas fa-trash fa-wf"></i>
                                </a>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 8px;" v-if="businessTurns.active && form.customer_id">
                            <div class="col-8">
                                <x-input v-if="form_plate.add" v-model="form_plate.plate"></x-input>
                                <x-select v-model="form.plate_number"
                                          placeholder="Seleccionar placa"
                                          :options="customer.plates"
                                          option-label="plate"
                                          option-value="plate"
                                          v-else></x-select>
                            </div>
                            <div class="col-4">
                                <div class="btn-group d-flex" role="group">
                                    <template v-if="!form_plate.add">
                                        <a class="btn btn-sm btn-default w-100"
                                           v-if="!form_plate.add"
                                           @click.prevent="form_plate.add = true">
                                            <i class="fas fa-plus fa-wf"></i>
                                        </a>
                                        <a class="btn btn-sm btn-default w-100"
                                           v-if="form.plate_number"
                                           @click="clickPlateRemove">
                                            <i class="fas fa-trash fa-wf"></i>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a class="btn btn-sm btn-default w-100"
                                           @click="savePlate">
                                            <i class="fas fa-save fa-wf"></i>
                                        </a>
                                        <a class="btn btn-sm btn-default w-100"
                                           @click="form_plate.add = false">
                                            <i class="fas fa-cancel fa-wf"></i>
                                        </a>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%; height: 40%; overflow-y: auto; overflow-x: hidden">
                          <div class="row" style="margin-top: 8px">
                            <div class="col-12">
                              <table class="table table-sm table-borderless mb-0 pos-list-items">
                                <template v-for="(item, index) in form.items">
                                    <tr :key="index">
                                        <td style="width: 10px; text-align: center; vertical-align: top"
                                            class="pos-list-label">
                                            {{ item.unit_type_id }}
                                        </td>
                                        <td style="width: 80px; vertical-align: top">
                                            <el-input v-model="item.item.aux_quantity"
                                                      @input="clickAddItem(item, index, true)"
                                                      @keyup.enter.native="keyupEnterQuantity"></el-input>
                                        </td>
                                        <td>
                                            <p class="item-description">
                                                {{ item.item.name }}
                                            </p>
                                            <small>
                                                {{ nameSets(item.item_id) }}
                                            </small>
                                        </td>
                                        <td style="width: 10px; text-align: center; vertical-align: top"
                                            class="pos-list-label">
                                            {{ currency_type.symbol }}
                                        </td>
                                        <td style="width: 80px; vertical-align: top">

                                            <template v-if="edit_unit_price">
                                                <el-input
                                                    v-model="item.total"
                                                    @input="calculateQuantity(index)"
                                                    @blur="blurCalculateQuantity(index)"
                                                    :readonly="!item.item.calculate_quantity">

                                                </el-input>
                                            </template>
                                            <template v-else>
                                                {{ item.total }}
                                            </template>

                                        </td>
                                        <td class="text-right"
                                            style="width: 36px; padding-left: 0; padding-right: 0; vertical-align: top">
                                            <a class="btn btn-sm btn-default" @click="clickItemRemove(index)">
                                                <i class="fas fa-trash fa-wf"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </template>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div class="pos-payment-div">
                          <div class="row" style="margin-top: 8px">
                              <div class="col-12">
                                  <table class="table table-sm text-right" style="margin: 0">
                                      <tr v-if="enabled_discount_global">
                                          <td style="padding: 0 8px;">DESCUENTOS (-)</td>
                                          <td style="padding: 0 8px;">:</td>
                                          <td style="padding: 0 8px;">
                                              <x-select v-model="discount_global_type"
                                                        :options="[{'id': '01', 'name': currency_type.symbol}, {'id': '02', 'name': '%'}]"
                                                        @input="changeDiscountGlobalType">
                                              </x-select>
                                          </td>
                                          <td style="padding: 0;">
                                              <el-input-number v-model="discount_global_amount"
                                                               :min="0"
                                                               class="input-custom"
                                                               controls-position="right"
                                                               @change="calculateTotal"></el-input-number>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td style="padding: 0 8px;">SUBTOTAL</td>
                                          <td style="padding: 0 8px; width: 30px;">:</td>
                                          <td style="padding: 0 8px; width: 80px">{{ currency_type.symbol }}</td>
                                          <td style="padding: 0 8px; width: 120px">{{ form.subtotal }}</td>
                                      </tr>
                                      <tr>
                                          <td style="padding: 0 8px;">IGV</td>
                                          <td style="padding: 0 8px;">:</td>
                                          <td style="padding: 0 8px;">{{ currency_type.symbol }}</td>
                                          <td style="padding: 0 8px;">{{ form.total_igv }}</td>
                                      </tr>
                                      <tr v-if="form.total_isc > 0">
                                          <td style="padding: 0 8px;">ISC</td>
                                          <td style="padding: 0 8px;">:</td>
                                          <td style="padding: 0 8px;">{{ currency_type.symbol }}</td>
                                          <td style="padding: 0 8px;">{{ form.total_isc }}</td>
                                      </tr>
                                      <tr v-if="form.total_plastic_bag_taxes > 0">
                                          <td style="padding: 0 8px;">ICBPER</td>
                                          <td style="padding: 0 8px;">:</td>
                                          <td style="padding: 0 8px;">{{ currency_type.symbol }}</td>
                                          <td style="padding: 0 8px;">{{ form.total_plastic_bag_taxes }}</td>
                                      </tr>
                                      <tr>
                                          <td style="font-weight: bolder; font-size: 18px; padding: 16px 8px;">IMPORTE TOTAL</td>
                                          <td style="font-weight: bolder; font-size: 18px; padding: 16px 8px;">:</td>
                                          <td style="font-weight: bolder; font-size: 18px; padding: 16px 8px;">{{ currency_type.symbol }}</td>
                                          <td style="font-weight: bolder; font-size: 18px; padding: 16px 8px;">{{ form.total }}</td>
                                      </tr>
                                      <tr v-if="form.total_payment > 0">
                                          <td style="padding: 0 8px;">IMPORTE PAGADO</td>
                                          <td style="padding: 0 8px;">:</td>
                                          <td style="padding: 0 8px;">{{ currency_type.symbol }}</td>
                                          <td style="padding: 0 8px;">{{ form.total_payment }}</td>
                                      </tr>
                                      <tr v-if="form.total_payment > 0">
                                          <td style="padding: 0 8px;">VUELTO</td>
                                          <td style="padding: 0 8px;">:</td>
                                          <td style="padding: 0 8px;">{{ currency_type.symbol }}</td>
                                          <td style="padding: 0 8px;">{{ form.total_difference }}</td>
                                      </tr>

                                  </table>
                              </div>
                          </div>
                          <div class="row" style="margin-top: 8px">
                              <div class="col-lg-12">
                                  <table class="table table-sm">
                                      <thead>
                                      <tr>
                                          <th style="padding-top: 0; padding-bottom: 0;">Método de pago</th>
                                          <th style="padding-top: 0; padding-bottom: 0;">Destino</th>
                                          <th style="padding-top: 0; padding-bottom: 0;">Referencia</th>
                                          <th style="padding-top: 0; padding-bottom: 0;">Monto</th>
                                          <th style="padding-top: 0; padding-bottom: 0; width: 50px; text-align: center">
                                              <button type="button"
                                                      class="btn waves-effect waves-light btn-xs btn-primary"
                                                      style="margin: 0"
                                                      @click.prevent="clickPaymentNew">
                                                  <i class="fa fa-plus"></i>
                                              </button>
                                          </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr v-for="(row, index) in form.payments" :key="index">
                                          <td>
                                              <x-select v-model="row.payment_method_type_id"
                                                        :options="payment_method_types"
                                                        @input="changePaymentMethodType(index)"></x-select>
                                          </td>
                                          <td>
                                              <x-select v-model="row.cash_id"
                                                        :options="all_cash"
                                                        v-if="!row.has_bank_account"
                                                        @input="changeCash(index)">
                                              </x-select>
                                              <x-select v-model="row.bank_account_id"
                                                        :options="bank_accounts"
                                                        @input="changeBankAccount(index)"
                                                        v-else>
                                              </x-select>
                                          </td>
                                          <td>
                                              <x-input v-model="row.reference"></x-input>
                                          </td>
                                          <td>
                                              <x-input v-model="row.payment"
                                                       @input="calculateTotalPayment"></x-input>
                                          </td>
                                          <td style="vertical-align: center; text-align: center">
                                              <button type="button"
                                                      class="btn waves-effect waves-light btn-xs btn-danger"
                                                      style="margin: 0"
                                                      @click.prevent="clickPaymentRemove(index)">
                                                  <i class="fa fa-trash"></i>
                                              </button>
                                          </td>
                                      </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div style="position: absolute; display: flex; height: 50px; width: 100%; bottom: 0; background-color: #fff; z-index: 1000">
                        <el-button :disabled="buttonPayment"
                                   :loading="loadingSubmit"
                                   class="submit btn btn-block btn-primary"
                                   style="margin: 0; font-size: 18px"
                                   @click="clickSubmit">GENERAR
                        </el-button>
                        <el-button :loading="loadingSubmitCancel"
                                   class="submit btn btn-block btn-danger"
                                   style="margin: 0 0 0 8px; font-size: 18px;"
                                   @click="clickCancel">CANCELAR
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <person-form :showDialog.sync="showDialogNewPerson"
                     type="customers"
                     :input_person="input_person"
                     :external="true"
                     :document_type_id="form.document_type_id"
                     @success="successCustomer"></person-form>

        <item-form :showDialog.sync="showDialogNewItem"
                   :external="true"></item-form>

        <history-sales-form :showDialog.sync="showDialogHistorySales"
                            :item_id="history_item_id"
                            :customer_id="form.customer_id"></history-sales-form>

        <history-purchases-form :showDialog.sync="showDialogHistoryPurchases"
                                :item_id="history_item_id"></history-purchases-form>

        <warehouses-detail :showDialog.sync="showWarehousesDetail"
                           :warehouses="warehousesDetail"
                           :unit_type="unittypeDetail"
                           :item_unit_types="[]"></warehouses-detail>

        <item-unit-types :showDialog.sync="showDialogItemUnitTypes"
                         :itemUnitTypes="itemUnitTypes"></item-unit-types>

        <options-form :recordId="documentNewId"
                      :resource="resourceOptions"
                      :showDialog.sync="showDialogOptions"
                      :response-document="responseDocument"
                      :response-sunat="responseSunat"></options-form>
    </div>
</template>
<style>
.el-select-dropdown__item.hover {
    /* background-color: red; */
    background-color: #e6e9ee;
}

/* The heart of the matter */
.testimonial-group > .row {
    overflow-x: auto;
    white-space: nowrap;
    overflow-y: hidden;
}

.testimonial-group > .row > .col-sm-3 {
    display: inline-block;
    float: none;
}

@media (max-width: 1024px) {
  .pos-payment-div {
    height: 20%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
/* Decorations */
.col-sm-3 {
    height: 70px;
    margin-right: 0.5%;
    color: white;
    font-size: 18px;
    padding-bottom: 20px;
    padding-top: 18px;
    font-weight: bold;
}

.card-block {
    min-height: 220px;
}

.ex1 {
    overflow-x: scroll;
}

.cat_c {
    width: 100px;
    margin: 1%;
    padding: 3px;
    font-weight: bold;
    color: white;
    min-height: 90px;
}

.cat_c p {
    color: white;
}

.c-width {
    width: 80px !important;
    padding: 0 !important;
    margin-right: 0 !important;
}

.el-select-dropdown {
    max-width: 80% !important;
    margin-right: 1% !important;
}

.ws-flotante {
    display: none;
}
</style>

<script>
import Keypress from "vue-keypress";
import {calculateRowItem, fCalculateTotal, fCalculateDiscountGlobal} from "../../../helpers/functions";
import FastPayment from "./partials/fast_payment_garage.vue";
import ItemForm from "./partials/form.vue";
import {functions, exchangeRate} from "../../../mixins/functions";
import HistorySalesForm from "./history/sales.vue";
import HistoryPurchasesForm from "./history/purchases.vue";
import PersonForm from "../persons/form.vue";
import WarehousesDetail from "../items/partials/warehouses.vue";
import queryString from "query-string";
import TableItems from "./partials/table.vue";
import ItemUnitTypes from "./partials/item_unit_types.vue";
import {mapActions, mapState} from "vuex/dist/vuex.mjs";
import XSelect from "../../../components/Form/XSelect.vue";
import OptionsForm from "./partials/options.vue";
import XInput from "../../../components/Form/XInput.vue";
import moment from "moment";

export default {
    props: ["configuration", "soapCompany", "businessTurns", "typeUser", "isPrint"],
    components: {
        XInput,
        OptionsForm,
        XSelect,
        FastPayment,
        ItemForm,
        HistorySalesForm,
        HistoryPurchasesForm,
        PersonForm,
        WarehousesDetail,
        ItemUnitTypes,
        Keypress,
        TableItems
    },
    mixins: [functions, exchangeRate],
    data() {
        return {
            loading: false,
            loadingSubmit: false,
            loadingSubmitCancel: false,
            place: "cat",
            showDialogOptions: false,
            showDialogItemUnitTypes: false,
            history_item_id: null,
            search_item_by_barcode: false,
            warehousesDetail: [],
            unittypeDetail: [],
            input_person: {},
            showDialogHistoryPurchases: false,
            showDialogHistorySales: false,
            showDialogNewPerson: false,
            showDialogNewItem: false,
            is_payment: false, //aq
            // is_payment: true,//aq
            showWarehousesDetail: false,
            resource: "pos",
            recordId: null,
            input_item: "",
            items: [],
            all_items: [],
            affectation_igv_types: [],
            all_customers: [],
            customers: [],
            establishment: null,
            currency_type: {},
            form_item: {},
            customer: {},
            row: {},
            user: {},
            form: {},
            categories: [],
            colors: ["#1cb973", "#bf7ae6", "#fc6304", "#9b4db4", "#77c1f3"],
            pagination: {},
            category_selected: "",
            focusClienteSelect: false,
            itemUnitTypes: [],
            affectations_exonerated_igv: ['10', '20'],
            searchFromBarcode: false,
            total_discount_no_base: 0,
            all_discounts: [],
            filter_discounts: [],
            discount_types_item: [],
            series: [],
            enabled_discount_global: true,
            discount_global_type: '01',
            discount_global_amount: 0,
            buttonPayment: false,
            responseDocument: {},
            responseSunat: null,
            documentNewId: null,
            resourceOptions: null,
            formCashDocument: {},
            amount: 0,
            enter_amount: 0,
            difference: 0,
            payments: [],
            payment_method_types: [],
            payment_destinations: [],
            bank_accounts: [],
            all_cash: [],
            form_plate: {add: false, plate: null, id: null},
            establishmentId: null,
            sellerId: null
        };
    },
    async created() {
        this.loadConfiguration()
        await this.initForm()
        await this.getTables()
        this.initFormData()
        await this.getPercentageIgv()
        await this.initCurrencyType()
        this.form.establishment_id = this.establishment.id
        this.enabledSearchItemByBarcode()
        // this.selectDefaultCustomer()
        await this.selectDefaultDocumentType()
        this.filterSeries()
        // await this.changeCustomer()
    },
    computed: {
        getAffectationExoneratedIgv() {
            return this.affectation_igv_types.filter(row => {
                return this.isExoneratedIgv(row.id)
            })
        },
        ...mapState([
            'config',
        ]),
        edit_unit_price() {
            if (this.typeUser === 'admin') {
                return true
            }
            if (this.typeUser === 'seller') {
                return this.configuration.allow_edit_unit_price_to_seller
            }
            return false
        }
    },
    methods: {
        ...mapActions(['loadConfiguration']),
        async getTables() {
            await this.$http.get(`/store/get_pos_tables`)
                .then(response => {
                    let data = response.data
                    this.user = data.user
                    this.establishment = data.establishment
                    this.all_discounts = data.all_discounts
                    this.affectation_igv_types = data.affectation_igv_types
                    this.all_customers = data.customers
                    this.currency_types = data.currency_types
                    this.discount_types_item = data.discount_types_item
                    this.all_series = data.series
                    //this.cards_brand = data.cards_brand
                    this.sellers = data.sellers
                    this.sellerId = data.seller_id
                    this.establishmentId = data.establishment_id

                    this.renderCategories(data.categories)
                })
            await this.$http.get(`/store/get_payment_tables`)
                .then(response => {
                    this.payment_method_types = response.data.payment_method_types
                    this.payment_destinations = response.data.payment_destinations
                    this.bank_accounts = response.data.bank_accounts
                    this.all_cash = response.data.all_cash
                })

            // await this.initForm()
        },
        initForm() {
            this.form = {
                id: null,
                operation_type_id: '0101',
                establishment_id: null,
                document_type_id: "03",
                series: null,
                prefix: null,
                number: "#",
                date_of_issue: moment().format("YYYY-MM-DD"),
                time_of_issue: moment().format("HH:mm:ss"),
                date_of_due: moment().format("YYYY-MM-DD"),
                customer_id: null,
                currency_type_id: "PEN",
                purchase_order: null,
                exchange_rate_sale: 1,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_plastic_bag_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                total: 0,
                total_payment: 0,
                total_retention: 0,
                total_detraction: 0,
                subtotal: 0,
                total_igv_free: 0,
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                payments: [],
                hotel: {},
                additional_information: null,
                actions: {
                    format_pdf: "a4"
                },
                reference_data: null,
                filter_discount_id: null,
                total_difference: 0,
                seller_id: null,
            };
            this.total_discount_no_base = 0
            this.total_global_discount = 0
            this.total_global_charge = 0
            this.discount_global_amount = 0
            this.initFormItem();
            this.changeDateOfIssue();
            this.initInputPerson();
            this.changeDateOfIssue()
            this.changeExchangeRate()
        },
        initFormData() {
            this.form.establishment_id = this.establishmentId
            this.form.seller_id = this.sellerId
            this.selectDefaultCustomer()
            this.changeCustomer()
             //this.form.operation_type_id = (this.operation_types.length > 0) ? this.operation_types[0].id : null
            // this.form.document_type_id = (this.document_types.length > 0) ? this.document_types[0].id : null
        },
        initFormItem() {
            this.form_item = {
                item_id: null,
                item: {},
                affectation_igv_type_id: null,
                affectation_igv_type: {},
                has_isc: false,
                system_isc_type_id: null,
                calculate_quantity: false,
                percentage_isc: 0,
                suggested_price: 0,
                quantity: 1,
                aux_quantity: 1,
                unit_price_value: 0,
                unit_price: 0,
                charges: [],
                discounts: [],
                attributes: [],
                has_igv: false,
                has_plastic_bag_taxes: false,
            };
        },
        resetForm() {
            this.initForm()
            this.initFormData()
            this.selectDefaultDocumentType()
            this.filterSeries()
            this.selectDefaultCustomer()
            // this.clickPaymentAdd()
        },
        enabledSearchItemByBarcode() {
            if (this.configuration.search_item_by_barcode) {
                this.search_item_by_barcode = true
            }
        },
        selectDefaultDocumentType() {
            // console.log('selectDefaultDocumentType')
            if (this.configuration.default_document_type_80) {
                this.form.document_type_id = "80"
            } else if (this.configuration.default_document_type_03) {
                this.form.document_type_id = "03";
            } else {
                this.form.document_type_id = this.customer.identity_document_type_id === "6" ? "01" : "03";
            }
        },
        isExoneratedIgv(affectation_igv_type_id) {
            return this.affectations_exonerated_igv.includes(affectation_igv_type_id)
        },
        allowedChangeAffectationExoneratedIgv(affectation_igv_type_id) {
            if (this.configuration) {
                return (this.configuration.change_affectation_exonerated_igv && this.isExoneratedIgv(affectation_igv_type_id))
            }
            return false
        },
        changeAffectationExoneratedIgv(affectation_igv_type, item) {
            const exist_item = _.find(this.form.items, {item_id: item.item_id})
            if (exist_item) {
                if (exist_item.affectation_igv_type_id !== affectation_igv_type.id) {
                    this.$message.warning('Ya agregó el producto con otro tipo de afectación, para aplicar el cambio debe eliminarlo y agregarlo nuevamente.')
                }
            }
            item.change_affectation_exonerated_igv = true
        },
        setOriginalAffectationToItems() {
            if (this.configuration !== undefined && this.configuration.change_affectation_exonerated_igv) {
                this.items.forEach(row => {
                    if (row.change_affectation_exonerated_igv !== undefined &&
                        row.change_affectation_exonerated_igv &&
                        row.sale_affectation_igv_type_id !== row.original_affectation_igv_type_id) {
                        row.sale_affectation_igv_type_id = row.original_affectation_igv_type_id
                    }
                })
            }
        },
        keyupEnterQuantity() {
            this.initFocus()
        },
        handleFn112(response) {
            this.search_item_by_barcode = !this.search_item_by_barcode
        },
        handleFn113() {
            this.setView("cat3")
        },
        handleFn115() {
            this.openDialogNewPerson()
        },
        initFocus() {
            this.$refs.ref_search_items.$el
                .getElementsByTagName("input")[0]
                .focus();
        },
        keyupTabCustomer(e) {
            if (e.keyCode === 9) {
                this.$refs.select_person.$el
                    .getElementsByTagName("input")[0]
                    .focus()
            }
        },
        keyupEnterAddItem() {
            if (this.place === "cat3") {
                return false
            }
            if (this.items.length === 1) {
                if (this.items[0].unit_type.length > 0 && this.configuration.select_available_price_list) {
                    this.itemUnitTypes = this.items[0].unit_type
                    this.showDialogItemUnitTypes = true
                } else {
                    this.clickAddItem(this.items[0], 0)
                    this.filterItems()
                    this.cleanInput()
                }
            } else {
                this.$message.warning(
                    "No puede añadir directamente el producto al listado, hay más de uno ubicado en la búsqueda"
                )
            }
        },
        filterCategories(id, mod = false) {
            this.category_selected = id ? id : ''
            this.getRecords()
            this.place = mod ? 'cat2' : 'prod'
        },
        getRecords() {
            this.loading = true
            return this.$http.get(`/${this.resource}/items?${this.getQueryParameters()}`)
                .then(response => {
                    this.all_items = response.data.data
                    this.filterItems()
                    this.pagination = response.data.meta
                    this.pagination.per_page = parseInt(response.data.meta.per_page)
                    if (response.data.meta.total > 0) {
                        this.pagination.total = response.data.meta.total
                    } else {
                        this.pagination.total = 0
                    }
                    this.fixItems()
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        getQueryParameters() {
            return queryString.stringify({
                garage: 1,
                page: this.pagination.current_page
                    ? this.pagination.current_page
                    : 1,
                input_item: this.input_item,
                cat: this.category_selected,
                limit: this.limit
            });
        },
        getColor(i) {
            return this.colors[i % this.colors.length];
        },
        initCurrencyType() {
            this.currency_type = _.find(this.currency_types, {
                id: this.form.currency_type_id
            });
        },
        initDateTimeIssue() {
            this.form.date_of_issue = moment().format("YYYY-MM-DD");
            this.form.time_of_issue = moment().format("HH:mm:ss");
            this.form.date_of_due = moment().format("YYYY-MM-DD");
        },
        clickOpenInputEditUP(index) {
            this.items[index].edit_unit_price = true;
            setTimeout(() => {
                const el = document.getElementById('editprice_' + index + '')
                el.focus();
                el.select();
            }, 200);
        },
        clickEditUnitPriceItem(index) {
            let item_search = this.items[index];
            this.items[index].sale_unit_price = this.items[
                index
                ].edit_sale_unit_price;
            this.items[index].edit_unit_price = false;
        },
        clickCancelUnitPriceItem(index) {
            this.items[index].edit_unit_price = false;
        },
        setPriceItem(price, index) {
            let value = 0;
            switch (price.price_default) {
                case 1:
                    value = price.price1;
                    break;
                case 2:
                    value = price.price2;
                    break;
                case 3:
                    value = price.price3;
                    break;
            }

            this.items[index].sale_unit_price = value;
            this.items[index].unit_type_id = price.unit_type_id;
            this.items[index].presentation = price;
            this.$message.success("Precio seleccionado");
        },
        clickWarehouseDetail(item) {
            this.unittypeDetail = item.unit_type;
            this.warehousesDetail = item.warehouses;
            this.showWarehousesDetail = true;
        },
        clickHistoryPurchases(item_id) {
            this.history_item_id = item_id;
            this.showDialogHistoryPurchases = true;
        },
        clickHistorySales(item_id) {
            if (!this.form.customer_id)
                return this.$message.error("Debe seleccionar el cliente");
            this.history_item_id = item_id;
            this.showDialogHistorySales = true;
        },
        keyupEnterCustomer() {
            if (this.place === "cat3") {
                return false;
            }
            if (this.form.customer_id) {
                this.clickPayment();
                return;
            }
            this.openDialogNewPerson()
        },
        openDialogNewPerson() {
            if (this.input_person.number) {
                if (!isNaN(parseInt(this.input_person.number))) {
                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = "1";
                            this.showDialogNewPerson = true;
                            break;

                        case 11:
                            this.input_person.identity_document_type_id = "6";
                            this.showDialogNewPerson = true;
                            break;
                        default:
                            this.input_person.identity_document_type_id = "6";
                            this.showDialogNewPerson = true;
                            break;
                    }
                }
            }
        },
        keyupCustomer(e) {
            if (this.place === "cat3") {
                return false;
            }
            if (e.key !== "Enter") {
                this.input_person.number = this.$refs.select_person.$el.getElementsByTagName(
                    "input"
                )[0].value;
                let exist_persons = this.customers.filter(customer => {
                    let pos = customer.description.search(
                        this.input_person.number
                    );
                    return pos > -1;
                });
                this.input_person.number = exist_persons.length === 0 ? this.input_person.number : null;
            }
        },
        calculateQuantity(index) {
            if (this.form.items[index].item.calculate_quantity) {
                let quantity = _.round(
                    parseFloat(this.form.items[index].total) /
                    parseFloat(this.form.items[index].unit_price),
                    4
                );
                if (quantity) {
                    this.form.items[index].quantity = quantity;
                    this.form.items[index].item.aux_quantity = quantity;
                } else {
                    this.form.items[index].quantity = 0;
                    this.form.items[index].item.aux_quantity = 0;
                }
            }
        },
        blurCalculateQuantity(index) {
            this.row = calculateRowItem(
                this.form.items[index],
                this.percentageIgv
            );
            this.row["unit_type_id"] = this.form.items[index].unit_type_id;
            this.form.items[index] = this.row;
            this.calculateTotal();
        },
        blurCalculateQuantity2(index) {
            this.row = calculateRowItem(
                this.form.items[index],
                this.percentageIgv
            );
            this.form.items[index] = this.row;
            this.calculateTotal();
        },
        changeCustomer() {
          // console.log(this.form.customer_id, "aqqquiii")
            this.form.plate_number = null
            this.form.plates = []
            this.customer = this.all_customers.find(row => {
                return row.id === this.form.customer_id
            })
            // console.log(this.all_customers, "aqqquiii")
            // console.log(this.customer, "aqqquiii")
            this.getFilterDiscounts();
            this.recalculateItems();
            this.calculateTotal();
        },
        clickCustomerRemove() {
            this.form.customer_id = null
            this.customer = null
            this.form.filter_discount_id = null
            this.filter_discounts = []
            this.recalculateItems()
            this.calculateTotal()
        },
        clickPlateRemove() {
            this.form.plate_number = null
        },
        changeFilterDiscounts() {
            this.recalculateItems();
            this.calculateTotal();
        },
        removeFilterDiscounts() {
            this.form.filter_discount_id = null
            this.recalculateItems();
            this.calculateTotal();
        },
        getFilterDiscounts() {
            this.form.filter_discount_id = null;
            this.filter_discounts = _.filter(this.all_discounts, (d) => {
                return d.person_option === '02' || d.person_id === this.form.customer_id
            })
        },
        async events() {
            await this.$eventHub.$on("initInputPerson", () => {
                this.initInputPerson();
            });
            await this.$eventHub.$on("cancelSaleGarage", () => {
              this.is_payment = false;
              this.initForm();
              this.changeExchangeRate();
              this.selectDefaultDocumentType()
              this.selectDefaultCustomer()
              this.filterSeries()
              this.$nextTick(() => {
                  this.initFocus();
                  if (this.$refs.componentFastPaymentGarage && !this.form.series) this.$refs.componentFastPaymentGarage.filterSeries()
              });
              this.form.establishment_id = this.establishment.id
            });

            await this.$eventHub.$on("reloadDataPersons", customer_id => {
                this.reloadDataCustomers(customer_id);
            });

            await this.$eventHub.$on("reloadDataItems", item_id => {
                this.reloadDataItems(item_id);
            });

            await this.$eventHub.$on("saleSuccess", () => {
                this.initForm();
                this.getTables();
                this.setOriginalAffectationToItems()
            });

            await this.$eventHub.$on("enterSelectItemUnitType", (unit_type) => {
                this.selectItemUnitType(unit_type)
            });

            this.form.establishment_id = this.establishment.id;
        },
        selectItemUnitType(unit_type) {
            this.setPriceItem(unit_type, 0)
            this.clickAddItem(this.items[0], 0)
            this.filterItems()
            this.cleanInput()
            this.initFocus()
        },
        initInputPerson() {
            this.input_person = {
                number: "",
                identity_document_type_id: ""
            };
        },
        async clickPayment() {
            if (!this.form.subtotal) {
                this.form.subtotal = this.form.total
            }
            let flag = 0
            this.form.items.forEach(row => {
                if (row.aux_quantity < 0 || row.total < 0 || isNaN(row.total)) {
                    flag++
                }
            });
            if (flag > 0)
                return this.$message.error("Cantidad negativa o incorrecta");
            if (!this.form.customer_id)
                return this.$message.error("Seleccione un cliente");
            if (!this.form.items[0])
                return this.$message.error("Seleccione un producto");
            this.form.establishment_id = this.establishment.id
            this.loading = true
            await this.sleep(800)
            this.is_payment = true
            this.loading = false
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async clickAddItem(item, index, input = false) {
            this.loading = true
            let exchangeRateSale = this.form.exchange_rate_sale
            let exist_item = this.form.items.find(row => {
                return row.item_id === item.item_id && row.unit_type_id === item.unit_type_id
            })
            let response = null
            if (exist_item) {
                let pos = this.form.items.indexOf(exist_item)
                if (input) {
                    response = await this.getStatusStock(
                        item.item_id,
                        exist_item.item.aux_quantity
                    );
                    if (!response.success) {
                        item.item.aux_quantity = item.quantity
                        this.loading = false
                        return this.$message.error(response.message)
                    }
                    exist_item.quantity = exist_item.item.aux_quantity
                } else {
                    response = await this.getStatusStock(
                        item.item_id,
                        parseFloat(exist_item.item.aux_quantity) + 1
                    )
                    if (!response.success) {
                        this.loading = false
                        return this.$message.error(response.message)
                    }
                    exist_item.quantity++
                    exist_item.item.aux_quantity++
                }

                let search_item_bd = this.items.find(row => {
                    return row.item_id === item.item_id
                })

                if (search_item_bd) {
                    exist_item.item.unit_price = parseFloat(
                        search_item_bd.sale_unit_price
                    )
                }

                exist_item.item.unit_price = exist_item.item.has_igv ? exist_item.item.sale_unit_price : exist_item.item.sale_unit_price * (1 + this.percentageIgv)
                exist_item.has_plastic_bag_taxes = exist_item.item.has_plastic_bag_taxes
                exist_item.discounts = []
                exist_item.discounts = this.filterDiscounts(exist_item.item_id)

                if (exist_item.item.currency_type_id === 'PEN' && this.form.currency_type_id === 'USD') {
                    exist_item.item.unit_price = exist_item.item.unit_price / this.form.exchange_rate_sale
                }
                if (exist_item.item.currency_type_id === 'USD' && this.form.currency_type_id === 'PEN') {
                    exist_item.item.unit_price = exist_item.item.unit_price * this.form.exchange_rate_sale
                }

                exist_item.currency_type_id = this.form.currency_type_id
                exist_item.unit_price = exist_item.item.unit_price
                //exist_item.item.unit_price = unit_price

                this.row = calculateRowItem(
                    exist_item,
                    this.percentageIgv
                )

                this.row["unit_type_id"] = item.unit_type_id
                this.form.items[pos] = this.row
            } else {
                response = await this.getStatusStock(item.item_id, item.presentation ? parseInt(item.presentation.quantity_unit) : 1)
                if (!response.success) {
                    this.loading = false
                    return this.$message.error(response.message)
                }

                this.form_item.item = {...item}
                this.form_item.name = this.form_item.item.name
                this.form_item.unit_price_value = this.form_item.item.sale_unit_price
                this.form_item.has_igv = this.form_item.item.has_igv
                this.form_item.has_plastic_bag_taxes = this.form_item.item.has_plastic_bag_taxes
                this.form_item.affectation_igv_type_id = this.form_item.item.sale_affectation_igv_type_id
                this.form_item.quantity = 1
                this.form_item.aux_quantity = 1

                let unit_price = this.form_item.has_igv ? this.form_item.unit_price_value : this.form_item.unit_price_value * (1 + this.percentageIgv)
                this.form_item.unit_price = unit_price
                this.form_item.item.unit_price = unit_price
                this.form_item.item.presentation = item.presentation ? item.presentation : null

                this.form_item.charges = [];
                this.form_item.discounts = [];
                this.form_item.attributes = [];
                this.form_item.affectation_igv_type = this.affectation_igv_types.find(row => {
                    return row.id === this.form_item.affectation_igv_type_id
                })

                this.form_item.discounts = this.filterDiscounts(this.form_item.item_id)

                if (this.form_item.item.currency_type_id === 'PEN' && this.form.currency_type_id === 'USD') {
                    unit_price = unit_price / this.form.exchange_rate_sale
                }
                if (this.form_item.item.currency_type_id === 'USD' && this.form.currency_type_id === 'PEN') {
                    unit_price = unit_price * this.form.exchange_rate_sale
                }

                this.form_item.currency_type_id = this.form.currency_type_id
                this.form_item.unit_price = unit_price
                this.form_item.item.unit_price = unit_price


                this.row = calculateRowItem(
                    this.form_item,
                    this.percentageIgv
                )

                this.row["unit_type_id"] = item.presentation ? item.presentation.unit_type_id : this.form_item.item.unit_type_id
                this.form.items.unshift(this.row)
                item.aux_quantity = 1
            }
            this.$notify({
                title: "",
                message: "Producto añadido!",
                type: "success",
                duration: 700
            });
            this.cleanInput()
            if (!input) {
                this.initFocus()
            }
            await this.calculateTotal()
            await this.setDefaultDataPriceSelected(item)
            this.loading = false
        },
        filterDiscounts(item_id) {
            let discounts = []
            if (this.all_discounts.length > 0 && this.form.filter_discount_id) {
                let discounts_all = this.all_discounts.filter(d => {
                    if (d.person_option === '03' && d.item_option === '03') {
                        return d.person_id === this.form.customer_id && d.item_id === item_id && d.id === this.form.filter_discount_id
                    }
                    if (d.person_option === '02' && d.item_option === '02') {
                        return d.id === this.form.filter_discount_id
                    }
                    if (d.person_option === '03' && d.item_option === '02') {
                        return d.person_id === this.form.customer_id && d.id === this.form.filter_discount_id
                    }
                    if (d.person_option === '02' && d.item_option === '03') {
                        return d.item_id === item_id && d.id === this.form.filter_discount_id
                    }
                })
                if (discounts_all.length > 0) {
                    discounts_all.forEach(d => {
                        d.lines.forEach(l => {
                            discounts.push(this.clickAddDiscount(d.name, l))
                        })
                    })
                }
            }
            return discounts
        },
        clickAddDiscount(name = null, d = null) {
            let discount_type = this.discount_types_item.find(d => {
                return d.id === '00'
            })
            let amount_base = 0
            let is_amount = false
            let type = '02'
            if (d) {
                if (d.type === '01') {
                    is_amount = true
                }
                amount_base = parseFloat(d.amount)
            }
            let description = name ? name : ('Descuento ' + (this.form.discounts.length + 1))
            return {
                //name: description,
                name_is_readonly: !!name,
                discount_type_id: discount_type.id,
                discount_type: discount_type,
                description: description,
                percentage: amount_base,
                factor: 0,
                amount_base: amount_base,
                amount: 0,
                base: 0,
                is_amount: is_amount,
                type: type
            }
        },
        recalculateItems() {
            let exchangeRateSale = this.form.exchange_rate_sale
            let items = []
            _.forEach(this.form.items, (item, index) => {
                item.discounts = this.filterDiscounts(item.item_id)
                let row = calculateRowItem(
                    item,
                    this.percentageIgv
                )
                row["unit_type_id"] = item.unit_type_id
                items.push(row)
            })
            this.form.items = items
        },
        setDefaultDataPriceSelected(item) {
            if (item.apply_price_selected_add_product !== undefined && item.apply_price_selected_add_product && this.configuration.price_selected_add_product) {
                item.sale_unit_price = parseFloat(item.aux_sale_unit_price)
                item.unit_type_id = item.aux_unit_type_id
                item.presentation = null
                item.apply_price_selected_add_product = false
            }
        },
        async getStatusStock(item_id, quantity) {
            let data = {}
            if (!quantity) quantity = 0
            await this.$http.get(`/${this.resource}/validate_stock/${item_id}/${quantity}`)
                .then(response => {
                    data = response.data
                })
            return data
        },
        async clickItemRemove(index) {
            this.form.items.splice(index, 1)
            this.calculateTotal()
        },
        calculateTotal() {
            this.form = Object.assign({}, this.form, fCalculateTotal(this.form))
            this.form = Object.assign({}, this.form,
                fCalculateDiscountGlobal(this.form, this.enabled_discount_global, this.discount_global_type, this.discount_global_amount))
            this.clickPaymentReset()
        },
        clickPaymentReset() {
            this.form.payments = []
            // this.clickPaymentAdd()
            // this.changePaymentMethodType(0)
            this.clickPaymentNew()
        },
        clickPaymentNew() {
            this.clickPaymentAdd()
            this.changePaymentMethodType(this.form.payments.length - 1)
        },
        clickPaymentAdd() {
            let payment_method_type_default = this.payment_method_types.find(row => {
                return row.is_default
            })
            if (!payment_method_type_default) {
                payment_method_type_default = this.payment_method_types[0]
            }
            let payment_method_type_id = payment_method_type_default.id
            this.form.payments.push({
                id: null,
                document_id: null,
                date_of_payment: moment().format('YYYY-MM-DD'),
                payment_method_type_id: payment_method_type_id,
                reference: null,
                payment_destination_id: null, //this.getPaymentDestinationId(),
                payment: this.form.total,
                payment_received: true,
                filename: null,
                temp_path: null,
                cash_id: null,
                bank_account_id: null,
                file_list: [],
                has_bank_account: false,
                currency_type_id: this.form.currency_type_id,
                exchange_rate_sale: this.form.exchange_rate_sale
            })
            this.calculateTotalPayment()
        },
        changePaymentMethodType(index) {
            let payment_method_type = _.find(this.payment_method_types, {'id': this.form.payments[index].payment_method_type_id})
            let has_bank_account = payment_method_type.has_bank_account
            this.form.payments[index].has_bank_account = has_bank_account
            if (has_bank_account) {
                if (this.bank_accounts.length > 0) {
                    this.form.payments[index].cash_id = null
                    this.form.payments[index].bank_account_id = this.bank_accounts[0].id
                }
            } else {
                if (this.all_cash.length > 0) {
                    this.form.payments[index].bank_account_id = null
                    this.form.payments[index].cash_id = this.all_cash[0].id
                }
            }
            this.changeCash(index)
            this.changeBankAccount(index)
        },
        changeCash(index) {
            if (this.form.payments[index].cash_id !== null) {
                this.form.payments[index].payment_destination_id = 'cash'
            }
        },
        changeBankAccount(index) {
            if (this.form.payments[index].bank_account_id !== null) {
                this.form.payments[index].payment_destination_id = this.form.payments[index].bank_account_id
            }
        },
        clickPaymentRemove(index) {
            if (this.form.payments.length === 1) {
                this.form.payments.splice(index, 1)
                this.clickPaymentNew()
            } else {
                this.form.payments.splice(index, 1)
            }
            this.calculateTotalPayment()
        },
        calculateTotalPayment() {
            let payment = 0
            this.form.payments.forEach(p => {
                if (p.payment !== '') {
                    payment += parseFloat(p.payment)
                }
            })
            this.form.total_payment = payment.toFixed(2)
            this.form.total_difference = (parseFloat(this.form.total_payment) - parseFloat(this.form.total)).toFixed(2)
        },
        changeDateOfIssue() {
            // this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
            //     this.form.exchange_rate_sale = response
            // })
        },
        changeExchangeRate() {
            this.searchExchangeRateByDate(this.form.date_of_issue).then(
                response => {
                    this.form.exchange_rate_sale = response;
                }
            );
        },
        selectDefaultCustomer() {
          console.log(this.establishment)
            if (this.establishment.customer_id && !this.form.customer_id) {
                this.form.customer_id = this.establishment.customer_id

            }
            this.changeCustomer()
            console.log("selectDefaultCustomer", this.form.customer_id)
        },
        renderCategories(source) {
            const contex = this
            this.categories = source.map((obj, index) => {
                return {
                    id: obj.id,
                    name: obj.name,
                    color: contex.getColor(index)
                };
            });
            this.categories.unshift({
                id: null,
                name: "Todos",
                color: "#2C8DE3"
            });
        },
        async searchItems() {
            if (this.input_item.length > 0) {
                this.loading = true
                let parameters = `input_item=${this.input_item}&cat=${this.category_selected}&garage=1`
                await this.$http.get(`/${this.resource}/search_items_cat?${parameters}`)
                    .then(response => {
                        this.all_items = response.data.data
                        if (response.data.data.length > 0) {
                            this.filterItems()
                            this.pagination = response.data.meta
                            this.pagination.per_page = parseInt(response.data.meta.per_page)
                            this.fixItems()
                        } else {
                            this.filterItems()
                        }
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                this.getRecords()
                this.filterItems()
            }
        },
        async searchItemsBarcode() {
            if (this.input_item.length > 1) {
                this.loading = true
                let parameters = `input_item=${this.input_item}`
                await this.$http.get(`/${this.resource}/search_items?${parameters}`)
                    .then(response => {
                        this.items = response.data.items
                        this.enabledSearchItemsBarcode()
                        if (this.items.length === 0) {
                            this.filterItems()
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                await this.filterItems()
            }
        },
        fixItems() {
            this.items = this.all_items.map(i => {
                /** Si description es vacio y hay nombre */
                if (i.name !== undefined) {
                    if (i.description === undefined || i.description == null) {
                        i.description = i.name
                    }
                }
                /** Si description es vacio aun */
                if (i.description == null) {
                    i.description = i.internal_id
                }
                return i;
            });
            this.all_items = this.items
        },
        enabledSearchItemsBarcode() {
            if (this.search_item_by_barcode) {
                if (this.items.length === 1) {
                    this.clickAddItem(this.items[0], 0);
                    this.filterItems()
                }
                this.cleanInput()
            }
        },
        changeSearchItemBarcode() {
            this.cleanInput()
        },
        cleanInput() {
            this.input_item = null
        },
        filterItems() {
            if (this.place === "cat3") {
                this.items = this.all_items
            } else {
                this.items = this.all_items.map(i => {
                    return i
                })
            }
        },
        async reloadDataCustomers(customer_id) {
            await this.$http.get(`/${this.resource}/table/customers`)
                .then(response => {
                    this.all_customers = response.data
                    this.form.customer_id = customer_id
                    this.changeCustomer()
                });
        },
        async reloadDataItems(item_id) {
            await this.$http.get(`/${this.resource}/table/items`)
                .then(response => {
                    this.all_items = response.data
                    this.fixItems()
                    this.filterItems()
                });
        },
        selectCurrencyType() {
            if (this.configuration.enabled_dolar_pos) {
                this.form.currency_type_id = this.form.currency_type_id === "PEN" ? "USD" : "PEN"
                this.changeCurrencyType()
            } else {
                this.$message.warning("El cambio a dolar esta desactivado")
            }
        },
        async changeCurrencyType() {
            this.currency_type = this.currency_types.find(row => {
                return row.id === this.form.currency_type_id
            })
            let items = []
            this.form.items.forEach(row => {
                if (row.currency_type_id === 'PEN' && this.form.currency_type_id === 'USD') {
                    row.unit_price = row.unit_price / this.form.exchange_rate_sale
                }
                if (row.currency_type_id === 'USD' && this.form.currency_type_id === 'PEN') {
                    row.unit_price = row.unit_price * this.form.exchange_rate_sale
                }
                row.currency_type_id = this.form.currency_type_id
                items.push(calculateRowItem(row, this.percentageIgv))
            })
            this.form.items = items
            this.calculateTotal()
        },
        back() {
            this.all_items = []
            this.place = "cat"
            this.loading = false
        },
        async setView(view) {
            this.place = view
            if (view === "cat3") {
                this.category_selected = ""
                await this.getRecords()
                this.$refs.table_items.reset()
            }
        },
        nameSets(id) {
            let row = this.items.find(x => x.item_id === id)
            if (row) {
                if (row.sets.length > 0) {
                    return row.sets.join("-")
                } else {
                    return ""
                }
            }
        },
        descriptionLength(item) {
            if (item.name === undefined) return 0
            if (item.name == null) return 0
            return item.name.length
        },
        filterSeries() {
            this.form.series = null
            this.series = this.all_series.filter(row => {
                return row.document_type_id === this.form.document_type_id
            });
            this.form.series = (this.series.length > 0) ? this.series[0].number : null
            if (!this.form.series) {
                return this.$message.warning('El establecimiento no tiene series disponibles para el comprobante')
            }
            // this.form.customer_id = null
            this.changeDocumentType()
            this.filter_discounts = []
            this.removeFilterDiscounts()
        },
        changeDocumentType() {
            if (this.form.document_type_id === '01') {
                this.customers = this.all_customers.filter(row => {
                    return row.identity_document_type_id === '6'
                })
            } else {
                this.customers = this.all_customers
            }
        },
        changeDiscountGlobalType() {
            this.calculateTotal()
        },
        clickSubmit() {
            if (!this.form.series) {
                return this.$message.warning('El establecimiento no tiene series disponibles para el comprobante')
            }

            if (this.form.customer_id === null) {
                return this.$message.warning('El cliente es requirido')
            }

            if (this.form.items.length === 0) {
                return this.$message.warning('Debe agregar productos')
            }

            if (this.form.total_difference < 0) {
                return this.$message.warning('Los pagos ingresados son incorrectos')
            }

            if (this.businessTurns.active) {
                if (this.form.document_type_id === '01' && !this.form.plate_number) {
                    return this.$message.warning('Debe ingresar placa')
                }
                if (this.configuration.bind_plate_number) {
                    if (this.form.filter_discount_id) {
                        if (this.customer.plates.length > 0 && this.form.plate_number == null) {
                            return this.$message.warning('Debe ingresar placa')
                        }
                    }
                }
            }

            this.$confirm('Generar comprobante?', 'Confirmar', {
                confirmButtonText: 'SI',
                cancelButtonText: 'NO',
                type: 'warning'
            }).then(async () => {
                await this.onSubmit()
            }).catch(() => {
            })
        },
        async onSubmit() {
            // if (!moment(moment().format("YYYY-MM-DD")).isSame(this.form.date_of_issue)) {
            //     return this.$message.error('La fecha de emisión no coincide con la del día actual');
            // }
            let resource_documents = ''
            let resource_payments = ''

            if (this.form.document_type_id === "80") {
                this.form.prefix = "NV"
                this.form.paid = 1
                resource_documents = "sale-notes"
                resource_payments = "sale_note_payments"
            } else {
                this.form.prefix = null;
                resource_documents = "documents"
                resource_payments = "document_payments"
                await this.assignPlateNumberToItems()
            }
            this.resourceOptions = resource_documents
            this.formCashDocument = {
                sale_note_id: null,
                document_id: null,
            }

            try {
                this.loading = true
                this.loadingSubmit = true

                this.responseSunat = null
                const response = await this.$http.post(`/${resource_documents}`, this.form)
                if (!response.data.success) {
                    this.$message.error(response.data.message)
                    return
                }
                this.responseDocument = response.data.data;

                if (this.form.document_type_id === "80") {
                    this.formCashDocument.sale_note_id = this.responseDocument.id
                } else {
                    this.formCashDocument.document_id = this.responseDocument.id
                    if (this.responseDocument.send_sunat) {
                        const sunatResponse = await this.$http.get(`/${resource_documents}/send/${this.responseDocument.id}`)
                        this.responseSunat = sunatResponse.data
                    }
                }

                this.documentNewId = response.data.data.id
                await this.resetForm()
                this.showDialogOptions = true
                if (this.isPrint) {
                    this.gethtml(resource_documents)
                }
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data
                } else {
                    this.$message.error(error.response.data.message)
                }
            } finally {
                this.loadingSubmit = false
                this.loading = false
            }
        },
        async saveCashDocument() {
            this.loading = true
            await this.$http.post(`/cash/cash_document`, this.formCashDocument)
                .then(response => {
                    if (response.data.success) {
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clickCancel() {
            this.$confirm('Desea cancelar la venta?', 'Cancelar', {
                confirmButtonText: 'SI',
                cancelButtonText: 'NO',
                type: 'warning'
            }).then(() => {
                this.resetForm()
            }).catch(() => {
            })
        },
        async assignPlateNumberToItems() {
            if (this.form.plate_number) {
                await this.form.items.forEach(item => {
                    let at = item.attributes.find(row => {
                        return row.attribute_type_id === '5010'
                    })
                    if (!at) {
                        item.attributes.push({
                            attribute_type_id: '7000',
                            description: "Gastos Art. 37 Renta:  Número de Placa",
                            value: this.form.plate_number,
                            start_date: null,
                            end_date: null,
                            duration: null,
                        })
                    }
                })
            }
        },
        async savePlate() {
            if (this.form_plate.plate === '' || this.form_plate.plate === null) {
                this.$message.error('Es requerido el número de la placa')
                return
            }
            this.customer.plates.push({plate: this.form_plate.plate})
            await this.$http.post(`/pos/customer_plate/${this.form.customer_id}`, this.customer.plates)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.form.plate_number = this.form_plate.plate
                        this.form_plate.add = false
                        this.form_plate.plate = null
                    } else {
                        this.$message.error('No se guardaron los cambios')
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        successCustomer(data) {
            this.all_customers.push(data.data[0])
            this.changeDocumentType()
            let customer = this.customers.find(row => {
                return row.id === data.id
            })
            if (customer) {
                this.form.customer_id = data.id
                this.changeCustomer()
            }
        },
        async getHtml(resource_documents) {
            this.loading = true
            this.form.datahtml = ""
            let route = `/printticket/document/${this.documentNewId}/ticket`
            if (resource_documents !== 'documents') {
                route = `/sale-notes/ticket/${this.documentNewId}/ticket`
            }
            await this.$http.get(route)
                .then(response => {
                    if (response.data.length > 0) {
                        this.form.datahtml = response.data
                        this.printTicket()
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async printTicket() {
            await this.sleep(400)
            let configPrint = getUpdatedConfig()
            let opts = getUpdatedConfig()
            let printData = [{
                type: 'html',
                format: 'plain',
                data: this.form.datahtml,
                options: opts
            }]
            qz.print(configPrint, printData).catch(displayError)
        },
    }
};
</script>
